import { render } from "./LanguageListItem.vue?vue&type=template&id=e0990360&scoped=true"
import script from "./LanguageListItem.vue?vue&type=script&lang=js"
export * from "./LanguageListItem.vue?vue&type=script&lang=js"

import "./LanguageListItem.vue?vue&type=style&index=0&id=e0990360&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0990360"]])

export default __exports__